import {
  AdSizeSAS,
  IDMTargeting,
  SASTargeting,
  Targeting,
} from "@digital-media/ad-model";
import { IDMResponse } from "../utils/targetingUtils";
import { manageRequesterApplication } from "./requesterApplicationMapper";

export const transformResponseToTargetingObject = (
  idmAccessGroupParams: IDMResponse[],
  idmUserGTID: string
) => {
  const idmParameterMapping: IDMTargeting = {
    multiNationalAccountIdentifier: "AgencyMACT",
    nationalAccountIdentifier: "AgencyNACT",
    pointOfSaleCity: "AgencyRegion",
    pointOfSaleCountry: "AgencyCountry",
    pointOfSaleIata: "IATAnumber",
    pointOfSalePcc: "PseudoCityCode",
    pointOfSaleTerminalIdentifier: "TerminalID",
  };

  const idmTargetingParams = {} as IDMTargeting;

  idmAccessGroupParams.forEach((param) => {
    Object.keys(idmParameterMapping).forEach((key) => {
      const idmTargetingKey = key as keyof IDMTargeting;
      if (param.name === idmParameterMapping[idmTargetingKey]) {
        idmTargetingParams[idmTargetingKey] = param.value;
      }
    });
  });
  idmTargetingParams.pointOfSaleTerminalIdentifier = idmUserGTID;

  return idmTargetingParams;
};

export const mapTargetingParametersForSAS = (
  targeting: Targeting
): SASTargeting => {
  const orgSystem = "1g1v";
  const targetingParamsSAS: SASTargeting = {
    ORGCITY: targeting.origin,
    CONNECTION: targeting.connection,
    HOME: targeting.home,
    ORGCOUNTRY: targeting.origCountry,
    DESCOUNTRY: targeting.destinationCountry,
    HOTDESTINATION: targeting.hotelDestination,
    CARDESTINATION: targeting.carDestination,
    AIR_SUPPLIER: targeting.airSupplier,
    CAR_SUPPLIER: targeting.carSupplier,
    HOTEL_SUPPLIER: targeting.hotelSupplier,
    CLASSOFSERVICE: targeting.classOfService,
    LOYPROGRAM: targeting.loyaltyProgram,
    GENDER: targeting.gender,
    LANGUAGE: targeting.language,
    DEVICE: targeting.device,
    PARTNER: targeting.partner,
    DESCITY: targeting.destinationCity,
    MNAACCT: targeting.multiNationalAccountIdentifier,
    NATACCT: targeting.nationalAccountIdentifier,
    POSCITY: targeting.pointOfSaleCity,
    POSCOUNTRY: targeting.pointOfSaleCountry,
    POSSTATEPROV: targeting.pointOfSaleStateOrProvinceCode,
    POSIATA: targeting.pointOfSaleIata,
    POSPCC: targeting.pointOfSalePcc,
    POSVERSION: targeting.pointOfSaleVersion,
    POSLNIATA: targeting.pointOfSaleTerminalIdentifier,
    PROMODATE: targeting.promotionDate,
    RAC: targeting.rateAccessCode,
    RC: targeting.rateCategory,
    TRANSTYPE: targeting.transactionType,
    VENDOR: targeting.vendorCode,
    VENDORTYPE: targeting.vendorType,
    VID: targeting.userId,
    VIEWID: getRandomNumber().toString(),
    RANDOM: getRandomNumber().toString(),
    ORGSYSTEM: orgSystem,
    SIZE: AdSizeSAS[targeting.size],
  };

  manageRequesterApplication(targetingParamsSAS, targeting);

  removeUndefinedParams(targetingParamsSAS);

  return targetingParamsSAS;
};

const getRandomNumber = (): number => {
  const min = 1;
  const max = 1000000000;
  return Math.round(Math.random() * (max - min) + min);
};

const removeUndefinedParams = (targetingParamsSAS: SASTargeting) => {
  Object.keys(targetingParamsSAS).forEach((key) => {
    const targetingKey = key as keyof SASTargeting;
    if (targetingParamsSAS[targetingKey] === undefined) {
      delete targetingParamsSAS[targetingKey];
    }
  });
};
